module.exports = __webpack_public_path__ + "static/media/98 - Yves Tumor - Strawberry Privilege.508ef45d.mp3";